import React from 'react';

function bold(text) {
  const nodes = [];
  let offset = 0;
  for (const match of text.matchAll(/\*\*([^*]+)\*\*/g)) {
    nodes.push(text.slice(offset, match.index));
    nodes.push(<strong key={match.index}>{match[1]}</strong>);
    offset = match.index + match[0].length;
  }
  nodes.push(text.slice(offset));
  return nodes;
}

export default function FormattedText({ children }) {
  if (typeof children !== 'string') return children ?? null;
  return <>{children.split(/(\r?\n)/).map((line, index) =>
    line.startsWith('##')
      ? <span key={index} style={{ fontSize: 'calc(1em + 2pt)', fontWeight: 700 }}>{bold(line.replace(/^##[ \t]?/, ''))}</span>
      : <React.Fragment key={index}>{bold(line)}</React.Fragment>
  )}</>;
}
